<template>
  <span
    ref="valueRef"
    v-tooltip.permanent="tooltip"
    :class="mainClasses"
  >
    {{ preparedValue }}
  </span>
</template>

<script setup lang="ts">
import { useResizeObserver } from '@vueuse/core'
import { computed, ref, useTemplateRef } from 'vue'

type Props = {
  entry: any
}

const props = defineProps<Props>()

const valueRef = useTemplateRef('valueRef')
const isValueEllipsis = ref(false)

const mainClasses = computed(() => ({
  'reorganize-tree-entries-value': typeof props.entry === 'object' && props.entry.key
}))

const tooltip = computed(() => {
  if (!isValueEllipsis.value) return
  return {
    content: preparedValue.value,
    handleResize: true,
  }
})

const preparedValue = computed(() => {
  if (typeof props.entry === 'object') {
    return props.entry.value
  }
  return props.entry
})

useResizeObserver(valueRef, () => {
  if (!valueRef.value) return
  isValueEllipsis.value = valueRef.value.offsetWidth < valueRef.value.scrollWidth
})
</script>

<style scoped>
.reorganize-tree-entries-value {
  @apply text-common-text;
  @apply truncate;
}
</style>
